import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import communityService from "../../api/communityService";

export const getpostdetails = createAsyncThunk("frontend/get-post-by-id", async (payload, { rejectWithValue }) => {
    try {
        const response = await communityService.getPostById(payload)
        return response.data
    } catch (error) {
        console.log(error);
        return rejectWithValue(error.response?.data || "Failed to fetch postdetails");
    }
})

const initialState = {
    postdetails: {},
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    successMessage: "",
};


const postdetailsSlice = createSlice({
    name: "postDetails",
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder
                .addCase(getpostdetails.pending, (state) => {
                    state.isLoading = true;
                    state.isSuccess = false;
                    state.isError = false;
                    state.errorMessage = "";
                })
                .addCase(getpostdetails.fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.isSuccess = true;
                    state.isError = false;
                    state.postdetails = action.payload.postdetails || {};
                    state.successMessage = action.payload.message || "Post Details Fetched Successfully";
                    state.errorMessage = ""
                })
                .addCase(getpostdetails.rejected, (state, action) => {
                    state.isLoading = false;
                    state.isSuccess = false;
                    state.isError = true;
                    state.errorMessage = action.payload;
                    state.successMessage = ""
                })
        }
})

export default postdetailsSlice.reducer;